import React, { useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import { BLOCKCHAINS } from '../../config/blockchains';
import "react-datepicker/dist/react-datepicker.css";

const EditToken = ({ token, onSave, isVisible, onClose }) => {
  const [editedTokenDatas, setEditedTokenDatas] = useState({});
  const [isOver, setIsOver] = useState(false);

  const handleInputChange = (event) => {
    const { ticker, value } = event.target;
    setEditedTokenDatas({ ...editedTokenDatas, [ticker]: value });
    const { checked } = event.target;
    setIsOver(checked);
  };

  const handleCloseClick = () => {
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const editedUserData = {
      ticker: formData.get("ticker") || token.ticker,
      blockchain:
      formData.get("blockchain") !== "Select"
    ? formData.get("blockchain")
    : token.blockchain,
      to_receive: formData.get("to_receive") || token.to_receive,
      vestingDate: editedTokenDatas.vestingDate,
      launchpad:
        formData.get("launchpad") !== "Select"
          ? formData.get("launchpad")
          : token.launchpad,
      claimPortal: formData.get("claimPortal") || token.claimPortal,
      paymentTransaction:
        formData.get("paymentTransaction") || token.paymentTransaction,
      isOver: isOver || token.isOver,
    };

    try {
      await axios.put(
        `https://cryptools-server-production.up.railway.app/api/user/editToken/${token.id}`,
        // `http://localhost:4000/api/user/editToken/${token.id}`,
        editedUserData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setEditedTokenDatas({});
      alert("Token data updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 z-[200] overflow-hidden backdrop-blur-lg ${
        isVisible ? "flex" : "hidden"
      }`}
    >
      <form
        onSubmit={handleSubmit}
        className="flex flex-col w-11/12 md:w-1/3 justify-around mt-2 item-left md:item-center p-4 border-2 rounded-lg z-[200] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/3 bg-white"
      >
        <label className="flex items-center w-full">
          <span className="w-1/6 text-left">Name:</span>
          <input
            className="block w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            type="text"
            name="ticker"
            value={editedTokenDatas.ticker}
            placeholder={token && token.ticker ? token.ticker : ""}
            onChange={handleInputChange}
          />
        </label>
          <label htmlFor="blockchain" className="flex items-center w-full">
          <span className="w-1/6 text-left">Blockchain</span>
          <select
            name="blockchain"
            id="blockchain"
            className="block w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-400 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            onChange={handleInputChange}
          >
            <option value="Select">
              Select a blockchain
            </option>
            {BLOCKCHAINS.map(chain => (
        <option key={chain.value} value={chain.value}>
          {chain.label}
        </option>
      ))}
          </select>
          </label>
        <label className="flex items-center w-full">
          <span className="w-1/6 text-left">To receive :</span>
          <input
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            type="text"
            name="to_receive"
            value={editedTokenDatas.to_receive}
            placeholder={token && token.to_receive ? token.to_receive : ""}
            onChange={handleInputChange}
          />
        </label>
        <label className="flex items-center w-full">
          <span className="w-1/6 text-left">Vesting :</span>
          <DatePicker
            className="w-full px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            selected={editedTokenDatas.vestingDate}
            // placeholder={token.vestingDate || ""}
            onChange={(date) => {
              handleInputChange({
                target: { name: "vestingDate", value: date },
              });
              setEditedTokenDatas({ ...editedTokenDatas, vestingDate: date });
            }}
            dateFormat="yyyy-MM-dd"
            value={editedTokenDatas.vestingDate}
            placeholderText={
              token && token.vestingDate ? token.vestingDate : ""
            }
          />
        </label>
        <label className="flex items-center w-full">
          <span className="w-1/6 text-left">Launchpad :</span>
          <select
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-400 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            name="launchpad"
            onChange={handleInputChange}
          >
            <option value="Select">Select a launchpad</option>
            <option value="DAO Maker">DAO Maker</option>
            <option value="Seedify">Seedify</option>
            <option value="Infinity Pad">Infinity Pad</option>
            <option value="Direct">Direct</option>
          </select>
        </label>
        <label className="flex items-center w-full">
          <span className="w-1/6 text-left">Claim Portal :</span>
          <input
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            type="text"
            name="claimPortal"
            value={editedTokenDatas.claimPortal}
            placeholder={token && token.claimPortal ? token.claimPortal : ""}
            onChange={handleInputChange}
          />
        </label>
        <label className="flex items-center w-full">
          <span className="w-1/6 text-left">Tx Link :</span>
          <input
            className="w-3/4 px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            type="text"
            name="paymentTransaction"
            value={editedTokenDatas.paymentTransaction}
            placeholder={
              token && token.paymentTransaction ? token.paymentTransaction : ""
            }
            onChange={handleInputChange}
          />
        </label>
        <label className="flex items-center w-full">
          <span className="w-1/6 text-left">Is over :</span>
          <input
            className="px-3 py-2 my-1 ml-2 leading-tight text-gray-700 border rounded shadow"
            type="checkbox"
            name="isOver"
            // value={editedTokenDatas.isOver}
            onChange={handleInputChange}
          />
        </label>
        <div className="flex justify-center gap-4 mt-4">
        <button
          type="submit"
          className="block px-5 py-2 mb-4 font-medium text-center text-white duration-150 bg-blue-600 rounded-lg hover:bg-blue-500 active:bg-blue-700 md:py-3 md:inline md:mr-4 md:mb-0"
        >
          Save
        </button>
        <button
          className="block px-5 py-2 mb-4 font-medium text-center text-white duration-150 bg-red-600 rounded-lg hover:bg-red-500 active:bg-red-700 md:py-3 md:inline md:mr-4 md:mb-0"
          type="button"
          onClick={handleCloseClick}
        >
          Close
        </button>
        </div>
      </form>
    </div>
  );
};

export default EditToken;
